import React, { useState } from "react"
import { Dropdown, MenuProps, message } from "antd"
import { changeOffAmazonSettingsType } from "../types/placement"
import { ApiChangeOffAmazonSettings } from "../api/campaignApi"

enum options {
  "MAXIMIZE_REACH" = "Increase reach",
  "MINIMIZE_SPEND" = "Limit off amazon spend",
}

interface SettingsForAdsServedOffAmazonProps {
  selectedCampaignIds: number[]
}

const SettingsForAdsServedOffAmazon: React.FC<SettingsForAdsServedOffAmazonProps> = ({
  selectedCampaignIds,
}) => {
  const [isCampaignActionsLoading, setIsCampaignActionsLoading] = useState(false)

  const changeOffAmazonSettings = (offAmazonBudgetControlStrategy: changeOffAmazonSettingsType) => {
    if (selectedCampaignIds.length === 0) {
      message.error("Please select at least one campaign")
      return
    }
    const profileId = localStorage.getItem("profileId") || ""
    setIsCampaignActionsLoading(true)
    ApiChangeOffAmazonSettings({
      campaignIds: selectedCampaignIds,
      offAmazonBudgetControlStrategy,
      profileId: profileId,
    })
      .then((data) => {
        if (data) {
          message.success("Settings for ads served off Amazon changed")
        } else {
          message.error("Settings for ads served off Amazon error")
        }
      })
      .catch((_e) => {
        message.error("Settings for ads served off Amazon error")
      })
      .finally(() => {
        setIsCampaignActionsLoading(false)
      })
  }

  const handleMenuClick: MenuProps["onClick"] = (event) => {
    switch (event.key) {
      case options.MAXIMIZE_REACH:
        changeOffAmazonSettings(changeOffAmazonSettingsType.MAXIMIZE_REACH)
        break
      case options.MINIMIZE_SPEND:
        changeOffAmazonSettings(changeOffAmazonSettingsType.MINIMIZE_SPEND)
        break
    }
  }

  const items: MenuProps["items"] = [
    {
      label: options.MAXIMIZE_REACH,
      key: options.MAXIMIZE_REACH,
    },
    {
      label: options.MINIMIZE_SPEND,
      key: options.MINIMIZE_SPEND,
    },
  ]

  const menuProps = {
    items,
    onClick: handleMenuClick,
  }

  return (
    <Dropdown.Button menu={menuProps} loading={isCampaignActionsLoading}>
      Settings for ads served off Amazon
    </Dropdown.Button>
  )
}

export default SettingsForAdsServedOffAmazon
